class LocalizeKeys {
  // #region General
  static TITLE = "LANDING_TITLE";
  static ROTATE_PHONE = "LANDING_ROTATE_PHONE";
  // #endregion

  // #region Login
  static LOGIN_TITLE = "LANDING_LOGIN_TITLE";
  static LOGIN_USER = "LANDING_LOGIN_USER";
  static LOGIN_USER_PLACEHOLDER = "LANDING_LOGIN_USER_PLACEHOLDER";
  static LOGIN_PASSWORD = "LANDING_LOGIN_PASSWORD";
  static LOGIN_PASSWORD_PLACEHOLDER = "LANDING_LOGIN_PASSWORD_PLACEHOLDER";
  static LOGIN_ERROR = "LANDING_LOGIN_ERROR";
  static LOGIN_BUTTON = "LANDING_LOGIN_BUTTON";
  // #endregion

  // #region Buttons
  static BUTTON_LOG_OUT = "LANDING_BUTTON_LOG_OUT";
  static BUTTON_PLAY = "LANDING_BUTTON_PLAY";
  static BUTTON_LANGUAGE = "LANDING_BUTTON_LANGUAGE";
  static BUTTON_BACK = "LANDING_BUTTON_BACK";
  // #endregion

  // #region Table
  static TABLE_VIEW = "LANDING_TABLE_VIEW";
  static TABLE_DELETE = "LANDING_TABLE_DELETE";
  static TABLE_EDIT = "LANDING_TABLE_EDIT";
  // #endregion

  // #region Invoices
  static INVOICES_TITLE = "LANDING_INVOICES_TITLE";
  static INVOICES_NOT_FOUND = "LANDING_INVOICES_NOT_FOUND";
  static INVOICES_ERROR = "LANDING_INVOICES_ERROR";
  static INVOICE = "LANDING_INVOICE";
  static INVOICE_DATE = "LANDING_INVOICE_DATE";
  static INVOICE_TRANSACTION_CODE = "LANDING_INVOICE_TRANSACTION_CODE";
  static INVOICE_CONCEPT = "LANDING_INVOICE_CONCEPT";
  static INVOICE_TOTAL = "LANDING_INVOICE_TOTAL";
  static INVOICE_TANGELO = "LANDING_INVOICE_TANGELO";
  static INVOICE_VAT = "LANDING_INVOICE_VAT";
  static INVOICE_0_VAT = "LANDING_INVOICE_0_VAT";
  // #endregion

  // #region Transactions
  static TRANSACTIONS_TITLE = "LANDING_TRANSACTIONS_TITLE";
  static TRANSACTIONS_NOT_FOUND = "LANDING_TRANSACTIONS_NOT_FOUND";
  static TRANSACTIONS_ERROR = "LANDING_TRANSACTIONS_ERROR";
  static MORE_INFO = "LANDING_MORE_INFO";
  static TRANSACTION_DATE = "LANDING_TRANSACTION_DATE";
  static TRANSACTION_EVENT = "LANDING_TRANSACTION_EVENT";
  static TRANSACTION_AMOUNT = "LANDING_TRANSACTION_AMOUNT";
  static TRANSACTION_ID = "LANDING_TRANSACTION_ID";
  static TRANSACTION_MATCH_ID = "LANDING_TRANSACTION_MATCH_ID";
  // #endregion

  // #region Install / PWA
  static INSTALL_APP = "LANDING_INSTALL_APP";
  static INSTALL_BUTTON = "LANDING_INSTALL_BUTTON";
  static INSTALL_APPSTORE = "LANDING_INSTALL_APPSTORE";
  static INSTALL_IOS_SHARE = "LANDING_INSTALL_IOS_SHARE";
  static INSTALL_IOS_EXTERNAL_BROWSER = "LANDING_INSTALL_IOS_EXTERNAL_BROWSER";
  static INSTALL_ANDROID_MANUAL = "LANDING_INSTALL_ANDROID_MANUAL";
  static INSTALL_DESKTOP_MAC_MANUAL = "LANDING_INSTALL_DESKTOP_MAC_MANUAL";
  static INSTALL_DESKTOP_WINDOWS_MANUAL = "LANDING_INSTALL_DESKTOP_WINDOWS_MANUAL";
  static INSTALL_EXTERNAL_BROWSER_MESSAGE = "LANDING_INSTALL_EXTERNAL_BROWSER_MESSAGE";
  static INSTALL_EXTERNAL_BROWSER_BUTTON = "LANDING_INSTALL_EXTERNAL_BROWSER_BUTTON";
  // #endregion

  // #region Language
  static LANGUAGE_EN = "USERFRONTEND_LANGUAGE_SELECTOR_EN";
  static LANGUAGE_ES = "USERFRONTEND_LANGUAGE_SELECTOR_ES";
  static LANGUAGE_DE = "USERFRONTEND_LANGUAGE_SELECTOR_DE";
  static LANGUAGE_FR = "USERFRONTEND_LANGUAGE_SELECTOR_FR";
  static LANGUAGE_IT = "USERFRONTEND_LANGUAGE_SELECTOR_IT";
  static LANGUAGE_PT = "USERFRONTEND_LANGUAGE_SELECTOR_PT";
  // #endregion

  // #region Home
  static HOME_HERO_TITLE = "LANDING_HOME_HERO_TITLE";
  static HOME_HERO_SUBTITLE = "LANDING_HOME_HERO_SUBTITLE";
  static HOME_DOWNLOAD_TITLE = "LANDING_HOME_DOWNLOAD_TITLE";
  // #endregion

  // #region Download
  static DOWNLOAD_REDIRECT_TITLE = "LANDING_DOWNLOAD_REDIRECT_TITLE";
  static DOWNLOAD_REDIRECT_TEXT = "LANDING_DOWNLOAD_REDIRECT_TEXT";
  // #endregion

  // #region Not Found
  static NOT_FOUND_TITLE = "LANDING_NOT_FOUND_TITLE";
  static NOT_FOUND_MESSAGE = "LANDING_NOT_FOUND_MESSAGE";
  static NOT_FOUND_BUTTON = "LANDING_NOT_FOUND_BUTTON";
  // #endregion
}

export default LocalizeKeys;
